/**
 * MASKA NAGRANIA — filtr WYŚWIETLANIA na potrzeby nagrania wideo.
 *
 * [polecenie właściciela 2026-09-13] „TO ma być tylko filtr na potrzeby nagrania, nic więcej […] imię
 * i nazwisko nazwij jako Konto Codebuilder #numer z users usera […] anonimizuj dane firmy (firma testowa),
 * domena jako domena.pl, numery zostaw, awatary zostaw […] Awatary zrób jako neutralne, CB inicjały […]
 * Tylko żeby mi to nie rozwaliło niczego".
 *
 * DLACZEGO NA DOM-IE, A NIE NA DANYCH Z API. Pola z imieniem i nazwiskiem występują we froncie w ~1450
 * miejscach w ~430 plikach, a nazwiska siedzą też WEWNĄTRZ zdań historii („Grzegorz Sosidko zatwierdził(a)
 * zapotrzebowanie"). Podmiana w odpowiedziach API musiałaby trafić w każde z tych miejsc i — co gorsze —
 * zmaskowana wartość w polu edycji wróciłaby na serwer przy zapisie. Maska na DOM-ie zmienia wyłącznie
 * WĘZŁY TEKSTOWE i atrybuty opisowe (title, aria-label, alt, placeholder). Wartości pól, treść edytora
 * (contenteditable / Quill) i to, co idzie na serwer, zostają nietknięte. Stąd „nic nie rozwala".
 *
 * [R26/R28/R32, właściciel 2026-09-13] DRUGA FALA — „zdjęcia z office365 i awatary nie zmieniły się na anonimowe,
 * stanowiska też nie", „dodaj też opcję anonimizacji numeru telefonu oraz stopki", „w eteczka też nie działa
 * anonimowość […] to jest tylko nakładka, to nie zapisuje". Co doszło i JAK, żeby nadal nic nie rozwalić:
 *  • ZDJĘCIA OSÓB (<img>): element zostaje w DOM-ie, podmieniamy tylko `src` na wygenerowany SVG z inicjałami
 *    aplikacji (bez żadnego pobierania) i znaczymy `data-maska-zdjecie`; obserwator pilnuje `src`/`srcset`, więc
 *    ponowny render Reacta jest maskowany od nowa. Rozpoznanie: adres zdjęcia (avatar/photo/signature-photo…),
 *    klasa własna lub przodka (avatar/photo/zdjecie/foto), albo `alt` z nazwiskiem ze słownika.
 *  • STANOWISKA: słownik niesie `stanowiska` (Office 365, kartoteka, stopki, umowy); tytuł wielowyrazowy
 *    („Dyrektor ds. IT") jest maskowany także wewnątrz zdania, jednowyrazowy („Kierownik") TYLKO gdy stanowi
 *    cały napis — inaczej zjadałby zwykłe słowa interfejsu. Numer jest stały per tytuł w tej sesji.
 *  • TELEFONY (opcja `maskujTelefony`, domyślnie WŁĄCZONA): numery o kształcie polskiego telefonu → „+48 000 000 000";
 *    numery zgłoszeń i ewidencji (KG-0926-0008, KROSMON00005, NR 12345) zostają. ⚠ Kod MPK w tej firmie ma 9 cyfr
 *    („571520000") — kształt komórki — więc o 9 cyfrach bez odstępów rozstrzyga OTOCZENIE: podpis tuż przed
 *    numerem („tel.", „MPK", „NIP") albo pole/kolumna/etykieta elementu (`kontekstNumeru`). Bez sygnału — maskuje.
 *    PESEL (11 cyfr) → „00000000000" zawsze. Daty zostają.
 *  • POLA (input/textarea, także edytowalne — [R28] e-teczka trzyma PESEL, telefon i adres W POLACH formularza, a
 *    pierwsza wersja maski pola pomijała w całości — stąd „w eteczce nie działa"): WARTOŚĆ POLA NIE JEST DOTYKANA.
 *    Maska rysuje zamaskowany napis jako tło SVG pola i robi prawdziwy tekst przezroczystym (`color: transparent`).
 *    To, co React trzyma w stanie i co idzie na serwer, zostaje prawdziwe — zapadka pilnuje, że moduł nigdy nie
 *    przypisuje `.value`. <option> bez własnego `value` dostaje prawdziwy tekst jako `value`, zanim jego napis
 *    zostanie zamaskowany (inaczej <select> oddałby do zapisu maskę). Pola z `[data-bez-maski]`, hasła, daty,
 *    liczby i edytor (Quill / contenteditable) są pomijane.
 *  • STOPKI I RAMKI: podglądy żyją w <iframe srcdoc>. Atrybut `srcdoc` jest maskowany jako dokument (DOMParser:
 *    węzły tekstowe, atrybuty opisowe, zdjęcia) — to działa także dla ramek z `sandbox`, do których dokumentu
 *    rodzic nie ma dostępu. Ramka tego samego pochodzenia dostaje własną maskę na `contentDocument` (te same
 *    reguły, rekurencyjnie). Opcja `maskujStopki` (domyślnie WŁĄCZONA) wyłącza WYŁĄCZNIE ramki podglądu stopki
 *    („stopk…" w tytule/klasie); ramki z dokumentami kadrowymi są maskowane zawsze.
 *    Ramka konfiguratora stopek w /admin (sandbox=allow-scripts, treść przez postMessage do stałego szkieletu) nie ma
 *    DOM-u dostępnego z zewnątrz — strona sama przepuszcza HTML przez `maskujHtmlPodgladuStopki` przed wysłaniem.
 *    NIE OBEJMUJE PDF-ów w ramkach — tam nie ma DOM-u do maskowania.
 *  • ZATRZYMANIE przywraca ekran (napisy, atrybuty, zdjęcia, srcdoc, wartości <option>, tytuł karty), a tytuł karty
 *    ustawiany przez stronę po starcie maski jest pilnowany osobnym obserwatorem na <head>. [T2, 2026-09-14] Maska schodzi
 *    też W TRAKCIE sesji (administrator wyłączył tryb — komponent MaskaNagrania sprawdza go ponownie), więc zatrzymanie
 *    zwraca raport { pelne, slady, rodzaje }: ślad maski, którego przywrócenie nie cofnęło = `pelne: false` → jedno
 *    przeładowanie strony po stronie komponentu.
 *  • SZUFLADY I PORTALE: obserwator stoi na `document.body`, więc treść wstawiana przez `createPortal` i szuflady
 *    (np. szczegóły pracownika w /admin/worktime-analytics) jest maskowana tak samo jak reszta strony.
 *  • NAZWISKO ROZBITE NA WĘZŁY: JSX `{o.nazwisko} {o.imie}` to trzy węzły tekstowe (e-teczka: lista osób, „Dodaj do
 *    akt: …"; ~65 miejsc w aplikacji). Sąsiednie węzły jednego elementu są maskowane RAZEM (`maskujBieg`), a każdy
 *    węzeł pamięta swój prawdziwy napis. Nazwisko rozbite na RÓŻNE elementy (`<b>{imie}</b> {nazwisko}`) — nie.
 *  • LOGINY, ŚCIEŻKI, SKRÓTY: „grzegorz.sosidko", „/personal/grzegorz_sosidko_krosno_com/…", „Sosidko_Grzegorz_CV.pdf"
 *    → „konto3" (kształt ścieżki zostaje); „G. Sosidko" / „Sosidko G." → „Konto … #3". Szuflada analityki czasu
 *    pracy pokazuje nazwy plików z OneDrive i ścieżki — tam nazwisko stoi właśnie w takiej postaci.
 *  • KOLEJNOŚĆ W `maskuj`: e-maile → telefony i PESEL → domeny → firmy → stanowiska → osoby. Zamienniki kończą się
 *    cyfrą („Konto … #3"), a numer tuż po „cyfrze i spacji" nie jest już rozpoznawany jako telefon.
 *
 * CZEGO MASKA NADAL NIE OBEJMUJE (świadomie, spisane dla właściciela w panelu):
 *  • PDF-y, eksporty XLSX, pobierane pliki i wysyłane maile — powstają poza DOM-em strony;
 *  • treść pól jest maskowana tylko na ekranie — edycja w nagraniu pokazuje maskę, a zapisuje prawdę.
 *
 * WYDAJNOŚĆ. Słownik ma ~2,7 tys. osób (konta + książka adresowa). Zamiast jednego wyrażenia z tysiącami
 * alternatyw każdy węzeł tekstowy jest najpierw tokenizowany, a słowa szukane w mapie rdzeni nazwisk;
 * wyrażenie osoby uruchamia się TYLKO dla kandydatów znalezionych w tym węźle.
 */

const ESC = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const L = "\\p{L}";
const KONCOWA_SAMOGLOSKA = /[aeiouyąęó]$/i;

/** „CodeBuilder" → „CB", „mPracownik" → „MP", „Krosno Intranet" → „KI", „Codebuilder" → „CO". Lustro reguły z serwera. */
export const inicjalyNazwyAplikacji = (nazwa) => {
    const tekst = String(nazwa || "").trim();
    if (!tekst) return "?";
    const slowa = tekst
        .replace(/([\p{Ll}\p{N}])(\p{Lu})/gu, "$1 $2")
        .split(/[^\p{L}\p{N}]+/u)
        .filter(Boolean);
    if (slowa.length === 0) return "?";
    if (slowa.length === 1) return slowa[0].slice(0, 2).toUpperCase();
    return (slowa[0][0] + slowa[1][0]).toUpperCase();
};

/**
 * Rdzeń słowa odporny na odmianę. Polska deklinacja zmienia nie tylko końcówkę, ale i spółgłoskę przed nią
 * („Sosidko" → „Sosidce", „Kowalski" → „Kowalskiego"), więc dłuższym słowom ścinamy DWIE ostatnie litery,
 * krótszym jedną samogłoskę, a bardzo krótkich („Koś", „Bąk") nie tykamy. Do rdzenia wyrażenie dopuszcza
 * do pięciu liter końcówki. Cena: „Jan Nowak" złapie też „Jana Nowakowskiego" — w masce nagrania lepiej
 * zamaskować cudze nazwisko pod obcym numerem niż zostawić prawdziwe.
 */
export const rdzen = (slowo) => {
    const s = String(slowo || "").trim();
    if (s.length >= 6) return s.slice(0, -2);
    if (s.length >= 4) return KONCOWA_SAMOGLOSKA.test(s) ? s.slice(0, -1) : s;
    return s;
};

/** Najdłuższa końcówka, jaką wyrażenie osoby dopuszcza po rdzeniu (spójna z szukaniem kandydatów). */
export const MAKS_KONCOWKA = 5;

const granica = (w) => `(?<![${L}\\p{N}])(?:${w})(?![${L}\\p{N}])`;

/**
 * Wyrażenie jednej osoby: obie kolejności („Imię Nazwisko", „Nazwisko Imię") i tolerancja na odmianę
 * („Grzegorza Sosidki", „Grzegorzowi Sosidce", „Annie Kowalskiej"). Zwraca null, gdy brakuje imienia albo nazwiska.
 */
export const wzorOsoby = (imie, nazwisko) => {
    const i = rdzen(imie);
    const n = rdzen(nazwisko);
    if (i.length < 2 || n.length < 2) return null;
    const wi = `${ESC(i)}${L}{0,${MAKS_KONCOWKA}}`;
    const wn = `${ESC(n)}${L}{0,${MAKS_KONCOWKA}}`;
    return new RegExp(granica(`${wi}\\s+${wn}|${wn}\\s+${wi}`), "giu");
};

/** „Gałach" → „Galach", „Żółć" → „Zolc": loginy, ścieżki OneDrive i nazwy plików piszą nazwiska bez ogonków. */
export const bezOgonkow = (s) => String(s || "").normalize("NFD").replace(/\p{M}/gu, "").replace(/ł/g, "l").replace(/Ł/g, "L");
const zOgonkamiLubBez = (s) => {
    const a = ESC(s);
    const b = ESC(bezOgonkow(s));
    return a === b ? a : `(?:${a}|${b})`;
};

/**
 * [R26, szuflada /admin/worktime-analytics] Osoba zapisana jak LOGIN albo w ścieżce: „grzegorz.sosidko",
 * „sosidko_grzegorz", „g.sosidko", „/personal/grzegorz_sosidko_krosno_com/…", „Grzegorz%20Sosidko" w adresie,
 * nazwa pliku „Sosidko_Grzegorz_CV.pdf". Zamiennik to lokalna część zastępczego e-maila („konto3"), więc ścieżka
 * i nazwa pliku zachowują kształt. Granicą jest wszystko poza literą i cyfrą (podkreślnik, kropka, ukośnik).
 */
export const wzorLoginuOsoby = (imie, nazwisko) => {
    const i = String(imie || "").trim();
    const n = String(nazwisko || "").trim();
    if (i.length < 2 || n.length < 2 || /\s/.test(i)) return null;
    const sep = "(?:[._+-]|%20)";
    const wi = zOgonkamiLubBez(i);
    const wn = zOgonkamiLubBez(n).replace(/-/g, "[-._]?").replace(/\s+/g, sep);
    const ini = zOgonkamiLubBez(i[0]);
    return new RegExp(`(?<![\\p{L}\\p{N}])(?:${wi}${sep}${wn}|${wn}${sep}${wi}|${ini}[._]${wn})(?![\\p{L}\\p{N}])`, "giu");
};

/** Skrót „G. Sosidko" / „Sosidko G." (nazwisko w odmianie: „G. Sosidki"). Zamiennik jak dla pełnego imienia i nazwiska. */
export const wzorSkrotuOsoby = (imie, nazwisko) => {
    const i = String(imie || "").trim();
    const n = rdzen(nazwisko);
    if (i.length < 2 || n.length < 2) return null;
    const ini = zOgonkamiLubBez(i[0]);
    const wn = `${ESC(n)}${L}{0,${MAKS_KONCOWKA}}`;
    return new RegExp(`(?<![${L}\\p{N}])(?:${ini}\\.\\s?${wn}|${wn}\\s+${ini}\\.)(?![${L}\\p{N}])`, "giu");
};

const SUFIKS_PRAWNY = /\s*(?:S\.?\s?A\.?|Sp\.?\s*z\s*o\.?\s*o\.?|Sp\.?\s*j\.?|S\.?\s?K\.?\s?A\.?|GmbH|Ltd\.?|Inc\.?)\s*$/iu;

const EMAIL = /[\p{L}\p{N}._%+-]+@[\p{L}\p{N}.-]+\.\p{L}{2,}/giu;

/** Słowo do szukania kandydatów (osoby, stanowiska) — litery z apostrofem i łącznikiem, cyfry dopuszczone w środku. */
const SLOWO = /[\p{L}][\p{L}\p{N}'’-]*/gu;

/** `.test` na wyrażeniu globalnym przesuwa lastIndex — tu zawsze od zera i bez śladu. */
const testujGlobalny = (re, tekst) => {
    re.lastIndex = 0;
    const wynik = re.test(tekst);
    re.lastIndex = 0;
    return wynik;
};

/* ── telefony i PESEL (R32) ───────────────────────────────────────────────────────────── */

/**
 * Kształty polskiego telefonu: 9 cyfr w typowych grupach (737 793 708 · 13 432 80 03 · 13 43 28 003),
 * numer kierunkowy w nawiasie, opcjonalny prefiks +48 / 0048 / „48 ". Granice: tuż przed i po numerze nie
 * może stać cyfra, litera, „-", „/" ani „#" (numery zgłoszeń, ewidencji, identyfikatory z kratką), przed
 * numerem nie może stać „cyfra + spacja" (kwota „1 234 567 890"), po numerze — przecinek/kropka z cyfrą.
 */
const GRUPY_TELEFONU = [
    "\\(\\d{2}\\)\\s?\\d{2}[\\s-]?\\d{2}[\\s-]?\\d{3}",
    "\\(\\d{2}\\)\\s?\\d{3}[\\s-]?\\d{2}[\\s-]?\\d{2}",
    "\\d{3}[\\s-]?\\d{3}[\\s-]?\\d{3}",
    "\\d{2}[\\s-]?\\d{3}[\\s-]?\\d{2}[\\s-]?\\d{2}",
    "\\d{2}[\\s-]?\\d{2}[\\s-]?\\d{2}[\\s-]?\\d{3}",
].join("|");
// Zakaz „cyfra + spacja" przed numerem (kwoty) NIE dotyczy jawnego „+48": „Konto … #3 +48 737 793 708" to telefon.
// „+" w zakazanych znakach przed numerem: bez tego drugie przejście łapało „48 000 000 000" z „+48 000 000 000".
export const TELEFON_RE = new RegExp(
    `(?<![\\p{L}\\p{N}#/.,_@+-])(?:\\+\\s?48[\\s-]?|(?<!\\d[\\s-])(?:00\\s?48[\\s-]?|48[\\s-])?)(?:${GRUPY_TELEFONU})(?![\\p{L}\\p{N}/-]|[.,]\\d)`,
    "gu",
);
export const TELEFON_ZASTEPCZY = "+48 000 000 000";

/**
 * [R32, poprawka po przeglądzie 2026-09-13] Numer ZAGRANICZNY: prefiks „+” albo „00” z kodem kraju innym niż 48, razem
 * 8–15 cyfr (limit E.164 — sprawdzany w `maskujTelefony`): „+49 170 1234567", „+44 20 7946 0958", „+1 (555) 123-4567",
 * „0049 170 1234567". Bez prefiksu numer zagraniczny nie różni się od kwoty ani kodu — takich nie ruszamy.
 */
export const TELEFON_ZAGRANICZNY_RE = new RegExp(
    `(?<![\\p{L}\\p{N}#/.,_@+-])(?:\\+|00)(?!48)[1-9]\\d{0,2}(?:[\\s-]?(?:\\(\\d{1,4}\\)|\\d{1,8})){2,6}(?![\\p{L}\\p{N}/-]|[.,]\\d)`,
    "gu",
);
/** Numer wewnętrzny po zamaskowanym telefonie („13 432 80 03 w. 210”) — cyfry też zastępcze: „w. 000”. */
const WEWNETRZNY_RE = new RegExp(`(${ESC(TELEFON_ZASTEPCZY)})(\\s?(?:w\\.|wew\\.?|ext\\.?)\\s?)\\d{1,5}(?![\\p{L}\\p{N}])`, "giu");

/**
 * Do 24 znaków tekstu tuż przed trafieniem. `kontekst.przed` to tekst POPRZEDNICH węzłów tekstowych tego samego
 * elementu — React składa „MPK {kod}" z dwóch węzłów, a podpis „MPK" ma rozstrzygać także wtedy.
 */
const tekstPrzed = (calosc, offset, kontekst) => {
    const wlasny = calosc.slice(Math.max(0, offset - 24), offset);
    const obcy = offset < 24 && kontekst && typeof kontekst.przed === "string" ? kontekst.przed : "";
    return (obcy + wlasny).slice(-24);
};

/**
 * Podpis telefonu tuż przed numerem (do 24 znaków wstecz w tym samym napisie): „tel.", „Telefon prywatny:",
 * „tel. kom.", „GSM", „fax". Taki numer jest telefonem bez względu na otoczenie.
 */
const PRZED_TELEFON = /(?<![\p{L}\p{N}])(?:tel|telefon\p{L}*|kom|kom[oó]rk\p{L}*|gsm|mobile|phone|fax|faks)(?:[\s.:]+\p{L}+\.?){0,2}\s*[.:]?\s*$/iu;
/**
 * Podpis NIE-telefonu tuż przed numerem: kod MPK (w tej firmie 9 cyfr — kształt komórki!), NIP, REGON, KRS,
 * numer ewidencyjny / inwentarzowy / seryjny / kadrowy, faktura, zamówienie, identyfikator. Taki numer zostaje.
 */
const PRZED_NIE_TELEFON = /(?<![\p{L}\p{N}])(?:mpk|nip|regon|krs|pesel|iban|konto|indeks|ewid\p{L}*|inw\p{L}*|nr|numer|id|kod|sn|s\/n|fv|faktur\p{L}*|zam\p{L}*)(?:[\s.:]+\p{L}+\.?)?\s*[.:#]?\s*$/iu;

/**
 * Telefony → „+48 000 000 000". Rozstrzygnięcie per trafienie, od najmocniejszego sygnału:
 *  1. podpis telefonu tuż przed numerem, jawny prefiks „+48"/„0048" albo otoczenie elementu = telefon → maskuj;
 *  2. podpis NIE-telefonu tuż przed numerem (MPK, NIP, nr ewid.…) → zostaw;
 *  3. otoczenie elementu mówi „inny numer" (pole/kolumna MPK, NIP, REGON…) → zostaw WYŁĄCZNIE gołe 9 cyfr stojące samotnie (`zostawWOtoczeniuInnym`);
 *  4. brak sygnału → MASKUJ. W nagraniu lepiej zamaskować za dużo niż pokazać czyjś numer komórki.
 * `kontekst.numery` („telefon" | „inny" | brak) liczy warstwa DOM z otoczenia elementu (`kontekstNumeru`).
 */
/**
 * [R32, poprawka po przeglądzie 2026-09-13] 🔴 Otoczenie „inny” (kolumna MPK, pole NIP, klasa „mpkSection”) działało
 * NA CAŁY ELEMENT: temat zgłoszenia „oddzwonić 737 793 708, MPK 571520000” stoi też w `title`, więc słowo „MPK” z tytułu
 * zostawiało na ekranie telefon — w treści i w dymku. Teraz otoczenie zostawia numer TYLKO, gdy:
 *  • to gołe 9 cyfr (kod MPK, REGON). Numer z odstępami albo łącznikami („737 793 708”) ma kształt telefonu i nim jest;
 *  • numer stoi w napisie SAM — poza nim (także w sąsiednich węzłach tego elementu) nie ma liter ani cyfr. Numer
 *    w zdaniu ma własny podpis tuż przed sobą (reguła 2) albo nie ma go wcale — i wtedy maska maskuje.
 * Wyjątek: `kontekst.podpowiedz` — placeholder pola z etykietą MPK („np. 571520000 — wybierz z Listy MPK”). Podpowiedź
 * pisze programista, nie użytkownik; przykładowy kod w niej nie jest niczyim telefonem.
 */
const zostawWOtoczeniuInnym = (trafienie, offset, calosc, kontekst) => {
    if (!/^\d{9}$/.test(trafienie)) return false;
    if (kontekst && kontekst.podpowiedz) return true;
    const reszta = calosc.slice(0, offset) + calosc.slice(offset + trafienie.length)
        + (kontekst && typeof kontekst.przed === "string" ? kontekst.przed : "")
        + (kontekst && typeof kontekst.po === "string" ? kontekst.po : "");
    return !/[\p{L}\p{N}]/u.test(reszta);
};

export const maskujTelefony = (tekst, kontekst) => {
    if (typeof tekst !== "string" || !/\d{2}/.test(tekst)) return tekst;
    const otoczenie = kontekst && kontekst.numery;
    const polskie = tekst.replace(TELEFON_RE, (trafienie, offset, calosc) => {
        const przed = tekstPrzed(calosc, offset, kontekst);
        if (otoczenie === "telefon" || /^(?:\+|00)/.test(trafienie) || PRZED_TELEFON.test(przed)) return TELEFON_ZASTEPCZY;
        if (PRZED_NIE_TELEFON.test(przed)) return trafienie;
        if (otoczenie === "inny" && zostawWOtoczeniuInnym(trafienie, offset, calosc, kontekst)) return trafienie;
        return TELEFON_ZASTEPCZY;
    });
    // Zagraniczne: zawsze z prefiksem, więc zawsze telefon; 8–15 cyfr razem (E.164).
    const zagraniczne = polskie.replace(TELEFON_ZAGRANICZNY_RE, (trafienie) => {
        const cyfry = (trafienie.match(/\d/g) || []).length;
        return cyfry >= 8 && cyfry <= 15 ? TELEFON_ZASTEPCZY : trafienie;
    });
    return zagraniczne.includes(TELEFON_ZASTEPCZY) ? zagraniczne.replace(WEWNETRZNY_RE, "$1$2000") : zagraniczne;
};

/** Czy w napisie stoi coś o kształcie telefonu (warstwa DOM liczy otoczenie elementu tylko wtedy — to kosztuje). */
export const wygladaNaTelefon = (tekst) => typeof tekst === "string" && /\d{2}/.test(tekst) && testujGlobalny(TELEFON_RE, tekst);

/**
 * PESEL: 11 cyfr jako osobny numer. Bez sumy kontrolnej — dane testowe bywają „na oko", a w nagraniu lepiej zamaskować
 * za dużo. Przed numerem nie może stać „+" (telefon „+48737793708" przy wyłączonych telefonach to nie PESEL), a podpis
 * innego identyfikatora tuż przed numerem (NIP, REGON, KSeF, nr ewidencyjny, faktura…) zostawia numer.
 */
export const PESEL_RE = /(?<![\p{L}\p{N}\/+-])\d{11}(?![\p{L}\p{N}\/-])/gu;
export const PESEL_ZASTEPCZY = "00000000000";
const PRZED_NIE_PESEL = /(?<![\p{L}\p{N}])(?:nip|regon|krs|ksef|iban|rachun\p{L}*|faktur\p{L}*|zam[oó]wie\p{L}*|ewid\p{L}*|inw\p{L}*|seryjn\p{L}*|sn|s\/n|indeks|kod|id)(?:[\s.:]+\p{L}+\.?)?\s*[.:#]?\s*$/iu;
export const maskujPesel = (tekst, kontekst) => {
    if (typeof tekst !== "string" || !/\d{11}/.test(tekst)) return tekst;
    return tekst.replace(PESEL_RE, (trafienie, offset, calosc) =>
        (PRZED_NIE_PESEL.test(tekstPrzed(calosc, offset, kontekst)) ? trafienie : PESEL_ZASTEPCZY));
};

/* ── stanowiska (R26c) ────────────────────────────────────────────────────────────────── */

const normalizujTytul = (t) => String(t || "").trim().replace(/\s+/g, " ");

/**
 * Indeks stanowisk: etykieta „Stanowisko #n" jest stała per tytuł (kolejność listy ze słownika). Tytuł
 * wielowyrazowy dostaje wyrażenie z granicami słów (także w środku zdania, bez względu na wielkość liter),
 * grupowane po pierwszym słowie — wyrażenia uruchamiają się tylko dla węzłów, w których to słowo występuje.
 * Tytuł jednowyrazowy („Kierownik", „Specjalista") jest maskowany WYŁĄCZNIE, gdy stanowi cały napis.
 */
export const zbudujIndeksStanowisk = (lista, etykieta = "Stanowisko") => {
    const cale = new Map();
    const wielowyrazowe = new Map();
    let liczba = 0;
    (lista || []).forEach((t) => {
        const n = normalizujTytul(t);
        if (n.length < 3) return;
        const klucz = n.toLowerCase();
        if (cale.has(klucz)) return;
        liczba += 1;
        const e = `${etykieta} #${liczba}`;
        cale.set(klucz, e);
        const slowa = n.split(" ");
        if (slowa.length < 2) return;
        const pierwsze = (slowa[0].toLowerCase().match(/[\p{L}][\p{L}\p{N}'’-]*/u) || [])[0];
        if (!pierwsze) return;
        const re = new RegExp(granica(ESC(n).replace(/\s+/g, "\\s+")), "giu");
        if (!wielowyrazowe.has(pierwsze)) wielowyrazowe.set(pierwsze, []);
        wielowyrazowe.get(pierwsze).push({ re, etykieta: e, dlugosc: n.length });
    });
    wielowyrazowe.forEach((l) => l.sort((a, b) => b.dlugosc - a.dlugosc));

    const maskujStanowiska = (tekst) => {
        if (liczba === 0 || typeof tekst !== "string") return tekst;
        const przyciety = tekst.trim();
        const caleTrafienie = cale.get(przyciety.replace(/\s+/g, " ").toLowerCase());
        if (caleTrafienie) return tekst.replace(przyciety, caleTrafienie);
        if (wielowyrazowe.size === 0) return tekst;
        const slowa = tekst.match(SLOWO);
        if (!slowa) return tekst;
        let w = tekst;
        const uzyte = new Set();
        for (const s of slowa) {
            const grupa = wielowyrazowe.get(s.toLowerCase());
            if (!grupa || uzyte.has(grupa)) continue;
            uzyte.add(grupa);
            for (const p of grupa) w = w.replace(p.re, p.etykieta);
        }
        return w;
    };
    return {
        maskujStanowiska,
        liczba,
        etykietaStanowiska: (t) => cale.get(normalizujTytul(t).toLowerCase()) || null,
    };
};

/* ── zdjęcia osób (R26a) ──────────────────────────────────────────────────────────────── */

export const ATRYBUT_ZDJECIA = "data-maska-zdjecie";
const KLASA_ZDJECIA = /avatar|photo|zdjec|foto|portret/i;
const ADRES_ZDJECIA = /avatar|photo|zdjeci|metaimage|signature-photo|\/users?\/\d+\/(picture|image)|graph\.microsoft\.com/i;
const escXml = (s) => String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
const klasaElementu = (el) => (typeof el.className === "string" ? el.className : (el.getAttribute && el.getAttribute("class")) || "");

/** Neutralne zdjęcie: kwadrat w kolorze tła z inicjałami aplikacji (kontener i tak przycina do koła). Zero pobrań. */
export const zdjecieZastepcze = (inicjaly) => {
    const t = escXml(String(inicjaly || "?").slice(0, 3));
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96"><rect width="96" height="96" fill="#e2e8f0"/>`
        + `<text x="48" y="50" text-anchor="middle" dominant-baseline="middle" font-family="system-ui,Segoe UI,Arial,sans-serif" font-size="38" font-weight="600" fill="#475569">${t}</text></svg>`;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

/**
 * Czy <img> to zdjęcie osoby: adres z końcówek zdjęć (nie dla data: — base64 może zawierać dowolne litery),
 * klasa własna albo przodka do 5 poziomów (avatar/photo/zdjecie/foto), albo `alt` z nazwiskiem ze słownika
 * (`zawieraOsobe` — tylko osoby, nie firmy: logo „Krosno Glass" nie jest zdjęciem człowieka).
 */
export const jestZdjeciemOsoby = (img, zawieraOsobe) => {
    if (!img || img.tagName !== "IMG") return false;
    if (img.hasAttribute(ATRYBUT_ZDJECIA)) return true;
    const src = img.getAttribute("src") || "";
    if (src && !src.startsWith("data:") && ADRES_ZDJECIA.test(src)) return true;
    const alt = img.getAttribute("alt") || "";
    if (alt.trim().length > 1 && typeof zawieraOsobe === "function" && zawieraOsobe(alt)) return true;
    let el = img;
    for (let i = 0; i < 5 && el; i += 1) {
        if (KLASA_ZDJECIA.test(klasaElementu(el))) return true;
        el = el.parentElement;
    }
    return false;
};

/** Atrybuty opisowe maskowane na elementach (tekst, który widać lub który czyta czytnik ekranu). */
const ATRYBUTY = ["title", "aria-label", "alt", "placeholder"];

/**
 * Buduje maskę ze słownika z serwera (`GET /api/nagranie/slownik`).
 * Zwraca { maskuj(tekst), inicjaly, etykietaOsoby(id) } — czyste funkcje, bez DOM-u.
 */
export const zbudujMaske = (slownik) => {
    const s = slownik || {};
    const nazwaAplikacji = s.nazwaAplikacji || "mPracownik";
    const inicjaly = (s.inicjaly || inicjalyNazwyAplikacji(nazwaAplikacji)).toUpperCase();
    const etykietaKonta = s.etykietaKonta || `Konto ${nazwaAplikacji}`;
    const etykietaKontaktu = s.etykietaKontaktu || `Kontakt ${nazwaAplikacji}`;
    const domenaZastepcza = s.domenaZastepcza || "domena.pl";
    const firmaZastepcza = s.firmaZastepcza || "Firma testowa";
    // Opcje z panelu administratora (AppSettings) — brak pola = włączone (R32: „to ważne!").
    const opcje = { telefony: s.maskujTelefony !== false, stopki: s.maskujStopki !== false };
    const stanowiska = zbudujIndeksStanowisk(s.stanowiska, s.etykietaStanowiska || "Stanowisko");
    const zamiennikZdjecia = zdjecieZastepcze(inicjaly);

    // ── osoby: mapa rdzeni nazwisk → kandydaci ────────────────────────────────────────────
    const indeks = new Map();
    const emaile = new Map();
    let liczbaOsob = 0;
    const dodajDoIndeksu = (klucz, osoba) => {
        if (!indeks.has(klucz)) indeks.set(klucz, []);
        const lista = indeks.get(klucz);
        if (!lista.includes(osoba)) lista.push(osoba);
    };
    const dodajOsobe = (imie, nazwisko, etykieta, email, lokalny) => {
        const re = wzorOsoby(imie, nazwisko);
        // Pierwsze przypisanie adresu wygrywa: konto przed teczką wstępną i kontaktem z tym samym adresem.
        const kluczEmaila = email ? String(email).trim().toLowerCase() : "";
        if (kluczEmaila && !emaile.has(kluczEmaila)) emaile.set(kluczEmaila, `${lokalny}@${domenaZastepcza}`);
        if (!re) return;
        liczbaOsob += 1;
        const osoba = {
            re,
            reSkrot: wzorSkrotuOsoby(imie, nazwisko),
            reLogin: wzorLoginuOsoby(imie, nazwisko),
            etykieta,
            lokalny,
            dlugosc: String(nazwisko).length,
        };
        const klucz = rdzen(nazwisko).toLowerCase();
        dodajDoIndeksu(klucz, osoba);
        // Login i ścieżka piszą nazwisko bez ogonków („galach") — kandydat ma się znaleźć także po takim słowie.
        const kluczBez = bezOgonkow(klucz);
        if (kluczBez !== klucz) dodajDoIndeksu(kluczBez, osoba);
    };
    (s.osoby || []).forEach((o) => dodajOsobe(o.imie, o.nazwisko, `${etykietaKonta} #${o.id}`, o.email, `konto${o.id}`));
    // [R28, poprawka po przeglądzie 2026-09-13] TECZKI WSTĘPNE (osoby bez konta): ta sama tabela /eteczka (filtr „bez konta”),
    // nagłówek teczki i panel teczki wstępnej. Teczka połączona z kontem = to samo konto („Konto … #id”), bez konta =
    // „Osoba … #numer” (numer stały: kolejność założenia teczki, liczy serwer).
    const etykietaOsobyWstepnej = s.etykietaOsobyWstepnej || `Osoba ${nazwaAplikacji}`;
    (s.osobyWstepne || []).forEach((w) => {
        if (w.kontoId) dodajOsobe(w.imie, w.nazwisko, `${etykietaKonta} #${w.kontoId}`, w.email, `konto${w.kontoId}`);
        else dodajOsobe(w.imie, w.nazwisko, `${etykietaOsobyWstepnej} #${w.numer}`, w.email, `osoba${w.numer}`);
    });
    (s.kontakty || []).forEach((k) => {
        let imie = k.imie;
        let nazwisko = k.nazwisko;
        if ((!imie || !nazwisko) && k.nazwaWyswietlana) {
            const czesci = String(k.nazwaWyswietlana).trim().split(/\s+/);
            if (czesci.length >= 2) { imie = czesci[0]; nazwisko = czesci[czesci.length - 1]; }
        }
        dodajOsobe(imie, nazwisko, `${etykietaKontaktu} #${k.numer}`, k.email, `kontakt${k.numer}`);
    });
    // Dłuższe nazwiska najpierw: „Kowalski-Nowak" przed „Kowalski" w tym samym węźle.
    indeks.forEach((lista) => lista.sort((a, b) => b.dlugosc - a.dlugosc));

    const znajdzKandydatow = (tekst) => {
        const wynik = new Set();
        const slowa = tekst.match(SLOWO);
        if (!slowa) return [];
        const szukaj = (w) => {
            // Rdzeń jest krótszy od słowa najwyżej o dwie ścięte litery i pięć liter końcówki.
            const min = Math.max(2, w.length - (MAKS_KONCOWKA + 2));
            for (let len = w.length; len >= min; len--) {
                const lista = indeks.get(w.slice(0, len));
                if (lista) lista.forEach((o) => wynik.add(o));
            }
        };
        for (const surowe of slowa) {
            const w = surowe.toLowerCase();
            szukaj(w);
            // „sosidko-grzegorz" (login, nazwa pliku) to jedno słowo z łącznikiem — części szukamy osobno.
            if (w.includes("-")) w.split("-").forEach((c) => { if (c.length >= 2) szukaj(c); });
        }
        return [...wynik].sort((a, b) => b.dlugosc - a.dlugosc);
    };

    // ── e-maile: znane → konto/kontakt, nieznane → stały numer w tej sesji ──────────────────
    const nieznane = new Map();
    const zamiennikEmaila = (adres) => {
        const klucz = adres.toLowerCase();
        // Adres już zamaskowany (drugie przejście po tym samym węźle) zostaje, jaki jest.
        if (klucz.endsWith(`@${domenaZastepcza}`)) return adres;
        if (emaile.has(klucz)) return emaile.get(klucz);
        if (!nieznane.has(klucz)) nieznane.set(klucz, `adres${nieznane.size + 1}@${domenaZastepcza}`);
        return nieznane.get(klucz);
    };

    // ── domeny i firmy ──────────────────────────────────────────────────────────────────────
    const domeny = [...new Set((s.domeny || []).map((d) => String(d).trim().toLowerCase()).filter((d) => d && d !== domenaZastepcza))]
        .sort((a, b) => b.length - a.length);
    const domenyRe = domeny.length
        ? new RegExp(`(?<![${L}\\p{N}-])(?:${domeny.map(ESC).join("|")})(?![${L}\\p{N}-])`, "giu")
        : null;

    const firmy = [];
    (s.firmy || []).forEach((f, i) => {
        const nazwa = String(f.nazwa || "").trim();
        if (!nazwa) return;
        const etykieta = i === 0 ? firmaZastepcza : `${firmaZastepcza} ${i + 1}`;
        const krotka = nazwa.replace(SUFIKS_PRAWNY, "").trim();
        const warianty = [nazwa];
        if (krotka && krotka !== nazwa && krotka.length >= 3) warianty.push(krotka);
        warianty.forEach((w) => firmy.push({ wariant: w, etykieta, dlugosc: w.length }));
    });
    firmy.sort((a, b) => b.dlugosc - a.dlugosc);
    const firmyRe = firmy.length
        ? new RegExp(granica(firmy.map((f) => ESC(f.wariant).replace(/\\\s|\s/g, "\\s+")).join("|")), "giu")
        : null;
    const etykietaFirmy = (trafienie) => {
        const t = trafienie.toLowerCase().replace(/\s+/g, " ");
        const f = firmy.find((x) => x.wariant.toLowerCase().replace(/\s+/g, " ") === t);
        return f ? f.etykieta : firmaZastepcza;
    };

    /**
     * Wszystkie wzory jednej osoby z zamiennikiem: pełne imię i nazwisko, login „grzegorz.sosidko" / „g.sosidko",
     * skrót „G. Sosidko". Login PRZED skrótem — skrót dopuszcza brak spacji po kropce i zjadłby „g.sosidko".
     */
    const wzoryOsoby = (o) => {
        const w = [[o.re, o.etykieta]];
        if (o.reLogin) w.push([o.reLogin, o.lokalny]);
        if (o.reSkrot) w.push([o.reSkrot, o.etykieta]);
        return w;
    };

    /**
     * `kontekst.numery` („telefon" | „inny") liczy warstwa DOM z otoczenia elementu — patrz `kontekstNumeru`;
     * `kontekst.przed` to tekst poprzednich węzłów tego samego elementu.
     *
     * 🔴 KOLEJNOŚĆ: telefony i PESEL PRZED nazwiskami, firmami i stanowiskami. Zamienniki kończą się cyfrą
     * („Konto CodeBuilder #3", „Stanowisko #1", „Firma testowa 2"), a wzór telefonu nie przyjmuje numeru tuż po
     * „cyfrze i spacji" (kwoty „1 234 567 890") — stopka „Grzegorz Sosidko 737 793 708" zostawiała prawdziwy numer.
     * E-maile idą pierwsze, bo lokalna część adresu bywa cyframi („737793708@gmail.com").
     */
    const maskuj = (tekst, kontekst) => {
        if (typeof tekst !== "string" || tekst.length < 2) return tekst;
        let w = tekst;
        if (w.includes("@")) w = w.replace(EMAIL, zamiennikEmaila);
        if (opcje.telefony) w = maskujTelefony(w, kontekst);
        w = maskujPesel(w, kontekst);
        if (domenyRe) w = w.replace(domenyRe, domenaZastepcza);
        if (firmyRe) w = w.replace(firmyRe, etykietaFirmy);
        w = stanowiska.maskujStanowiska(w);
        const kandydaci = znajdzKandydatow(w);
        for (const o of kandydaci) {
            for (const [re, zamiennik] of wzoryOsoby(o)) w = w.replace(re, zamiennik);
        }
        return w;
    };

    /**
     * [R28] Imię i nazwisko ROZBITE na kilka węzłów tekstowych jednego elementu. JSX `{o.nazwisko} {o.imie}` daje trzy
     * węzły („Sosidko", „ ", „Grzegorz") — a maska węzła widzi tylko jeden. `czesci` to napisy kolejnych węzłów PO masce
     * pojedynczych węzłów; zwraca nowe napisy albo null, gdy żadna osoba nie przechodzi przez granicę węzłów.
     * Zamiennik trafia do węzła, w którym zaczyna się trafienie; dalsze części trafienia w kolejnych węzłach znikają.
     */
    const maskujOsobyWPoprzek = (czesci) => {
        if (!Array.isArray(czesci) || czesci.length < 2) return null;
        const calosc = czesci.join("");
        if (calosc.length < 3) return null;
        const kandydaci = znajdzKandydatow(calosc);
        if (kandydaci.length === 0) return null;
        const starty = [];
        let poz = 0;
        for (const c of czesci) { starty.push(poz); poz += c.length; }
        const czescDla = (offset) => {
            let i = 0;
            while (i + 1 < starty.length && starty[i + 1] <= offset) i += 1;
            return i;
        };
        const trafienia = [];
        for (const o of kandydaci) {
            for (const [re, zamiennik] of wzoryOsoby(o)) {
                re.lastIndex = 0;
                let m = re.exec(calosc);
                while (m) {
                    const od = m.index;
                    const doK = od + m[0].length;
                    if (m[0].length === 0) { re.lastIndex += 1; m = re.exec(calosc); continue; }
                    const przezGranice = czescDla(od) !== czescDla(doK - 1);
                    if (przezGranice && !trafienia.some((t) => od < t.doK && doK > t.od)) trafienia.push({ od, doK, zamiennik });
                    m = re.exec(calosc);
                }
                re.lastIndex = 0;
            }
        }
        if (trafienia.length === 0) return null;
        trafienia.sort((a, b) => a.od - b.od);
        const wynik = czesci.map(() => "");
        const przepisz = (od, doK) => {
            czesci.forEach((c, i) => {
                const a = Math.max(od, starty[i]);
                const b = Math.min(doK, starty[i] + c.length);
                if (a < b) wynik[i] += calosc.slice(a, b);
            });
        };
        let kursor = 0;
        for (const t of trafienia) {
            przepisz(kursor, t.od);
            wynik[czescDla(t.od)] += t.zamiennik;
            kursor = t.doK;
        }
        przepisz(kursor, calosc.length);
        return wynik;
    };

    /** Czy w tekście stoi nazwisko ze słownika (tylko osoby — nie firmy, nie domeny). Do rozpoznawania zdjęć po `alt`. */
    const zawieraOsobe = (tekst) => {
        if (typeof tekst !== "string" || tekst.length < 3) return false;
        return znajdzKandydatow(tekst).some((o) => wzoryOsoby(o).some(([re]) => testujGlobalny(re, tekst)));
    };

    /**
     * Maska dla DOKUMENTU HTML podanego jako tekst (atrybut `srcdoc` ramki podglądu stopki). Parsujemy, maskujemy
     * węzły tekstowe, atrybuty opisowe i zdjęcia osób, oddajemy z powrotem jako HTML. Adresy obrazów i styli
     * zostają nietknięte — logo i układ stopki mają wyglądać jak naprawdę, tylko dane mają być cudze.
     */
    const maskujHtml = (html) => {
        if (typeof html !== "string" || html.length < 2 || typeof DOMParser === "undefined") return html;
        let d;
        try { d = new DOMParser().parseFromString(html, "text/html"); } catch { return html; }
        if (!d || !d.documentElement) return html;
        const walker = d.createTreeWalker(d.documentElement, 5 /* SHOW_ELEMENT | SHOW_TEXT */, {
            acceptNode: (n) => (n.nodeType === 1 && /^(SCRIPT|STYLE|NOSCRIPT)$/i.test(n.tagName) ? 2 : 1),
        });
        // Bez zmiany oddajemy DOKŁADNIE ten sam napis. Ponowna serializacja (DOCTYPE, formatowanie atrybutów) zmieniłaby
        // `srcdoc`, ramka przeładowałaby się bez potrzeby i jej `onLoad` (wysokość podglądu A4) poszedłby drugi raz.
        let zmiana = false;
        let n = walker.nextNode();
        while (n) {
            if (n.nodeType === 3) {
                const v = n.nodeValue;
                if (v && /\S/.test(v)) {
                    const kontekst = opcje.telefony && wygladaNaTelefon(v) ? { numery: kontekstNumeru(n.parentElement) } : undefined;
                    const m = maskuj(v, kontekst);
                    if (m !== v) { n.nodeValue = m; zmiana = true; }
                }
            } else {
                if (n.tagName === "IMG" && jestZdjeciemOsoby(n, zawieraOsobe) && n.getAttribute("src") !== zamiennikZdjecia) {
                    n.removeAttribute("srcset");
                    n.setAttribute("src", zamiennikZdjecia);
                    n.setAttribute(ATRYBUT_ZDJECIA, "");
                    zmiana = true;
                }
                for (const a of ATRYBUTY) {
                    const v = n.getAttribute(a);
                    if (v) { const m = maskuj(v); if (m !== v) { n.setAttribute(a, m); zmiana = true; } }
                }
            }
            n = walker.nextNode();
        }
        if (!zmiana) return html;
        // Fragment (treść podglądu wysyłana do ramki przez postMessage) wraca jako fragment, bez dopisanych <html>/<body>.
        // Parser przenosi <style>/<meta> sprzed treści do <head> — stąd head + body.
        if (!/<html[\s>]|<body[\s>]|<!doctype/i.test(html)) return d.head.innerHTML + d.body.innerHTML;
        const doctype = /^\s*<!doctype/i.test(html) ? "<!DOCTYPE html>" : "";
        return doctype + d.documentElement.outerHTML;
    };

    /**
     * [T2, właściciel 2026-09-14] ŚLAD MASKI: zamiennik osoby z numerem („Konto CodeBuilder #3”, „Kontakt … #1”, „Osoba … #2”)
     * albo zastępczy e-mail („konto3@domena.pl”). Po zatrzymaniu maski taki napis na ekranie znaczy, że zamaskowana treść
     * przeszła do stanu strony (skopiowany HTML, napis przepisany z DOM-u) i DOM jej nie odda — patrz `uruchomMaskeDom`.
     * Bez flagi `g`: `.test` nie przesuwa `lastIndex`.
     */
    const wzorSladu = new RegExp(
        `(?:${[etykietaKonta, etykietaKontaktu, etykietaOsobyWstepnej].map(ESC).join("|")})\\s#\\d`
        + `|(?<![\\p{L}\\p{N}._%+-])(?:konto|kontakt|osoba|adres)\\d+@${ESC(domenaZastepcza)}`,
        "u",
    );

    return {
        wzorSladu,
        maskuj,
        maskujHtml,
        maskujOsobyWPoprzek,
        zawieraOsobe,
        opcje,
        inicjaly,
        nazwaAplikacji,
        zdjecieZastepcze: zamiennikZdjecia,
        etykietaOsoby: (id) => `${etykietaKonta} #${id}`,
        etykietaStanowiska: stanowiska.etykietaStanowiska,
        liczbaOsob,
        liczbaStanowisk: stanowiska.liczba,
    };
};

/* ═══════════════════════════════════════════════════════════════════════════════════════════
   WARSTWA DOM
   ═══════════════════════════════════════════════════════════════════════════════════════════ */

/** Poddrzewa, do których maska NIE wchodzi: kod, edytor (Quill / contenteditable — treść idzie na serwer) i [data-bez-maski]. */
export const POMIJANE_DRZEWO = 'script,style,noscript,[contenteditable="true"],[contenteditable=""],.ql-editor,[data-bez-maski]';
/** Pola: ich WARTOŚĆ nie jest tykana (rysujemy maskę jako tło — patrz nagłówek), a tekst wewnątrz textarea zostaje. */
export const POLA = "input,textarea";
export const POMIJANE = `${POMIJANE_DRZEWO},${POLA}`;
const ATRYBUTY_OBSERWOWANE = [...ATRYBUTY, "src", "srcset", "srcdoc", "value"];
const INICJALY_NA_EKRANIE = /^\p{Lu}{1,3}$/u;
export const ATRYBUT_AWATARA = "data-maska-awatar";
export const ATRYBUT_POLA = "data-maska-pole";
export const ATRYBUT_RAMKI = "data-maska-ramka";
/** <option> bez własnego `value`: jego wartość to TEKST — maska dopisuje prawdziwy tekst jako `value`, patrz `maskujTekst`. */
export const ATRYBUT_OPCJI = "data-maska-opcja";
const TYPY_POL_TEKSTOWYCH = new Set(["", "text", "email", "tel", "search", "url"]);

/* ── otoczenie numeru: telefon czy kod MPK? ─────────────────────────────────────────────── */

const OTOCZENIE_TELEFON = /(?<![a-z])tel(?![a-z])|telefon|phone|mobile|kom[oó]rk|(?<![a-z])gsm(?![a-z])|(?<![a-z])fa(?:x|ks)(?![a-z])/i;
const OTOCZENIE_INNY = /mpk|(?<![a-z])nip(?![a-z])|regon|(?<![a-z])krs(?![a-z])|pesel|iban|n(?:ume)?r\.?\s*konta|rachun|indeks|ewiden|inwentar|seryjn|serial|faktur|zam[oó]wie/i;
const ATRYBUTY_OTOCZENIA = ["name", "id", "aria-label", "title", "placeholder", "autocomplete", "type", "list", "for"];

/** Klasa CSS Modules w produkcji to „Plik_lokalna__hash" — liczy się tylko część lokalna (nazwa pliku „RaportMpkPage" nie mówi nic o polu). */
const klasyLokalne = (el) => klasaElementu(el).split(/\s+/).filter(Boolean)
    .map((k) => { const m = k.match(/^[A-Za-z0-9-]+_(.+)__[A-Za-z0-9_-]+$/); return m ? m[1] : k; })
    .join(" ");

/** Podpis to krótki napis BEZ cyfr (podpis pola, nagłówek kolumny, <dt>). Napis z liczbą to wartość, nie podpis. */
const podpis = (t) => {
    const s = (t || "").trim();
    return s && s.length <= 40 && !/\d/.test(s) ? s : "";
};

const naglowekKolumny = (komorka) => {
    const tabela = komorka.closest && komorka.closest("table");
    const naglowki = tabela && tabela.tHead && tabela.tHead.rows;
    if (!naglowki || naglowki.length === 0 || typeof komorka.cellIndex !== "number" || komorka.cellIndex < 0) return "";
    const kom = naglowki[naglowki.length - 1].cells[komorka.cellIndex];
    return kom ? podpis(kom.textContent) : "";
};

/**
 * [R32] Czy numer o kształcie telefonu w tym elemencie JEST telefonem. Kod MPK w tej firmie ma 9 cyfr („571520000"),
 * czyli kształt numeru komórki — sam napis tego nie rozstrzygnie. Rozstrzyga otoczenie, od najbliższego poziomu
 * (element, rodzic, dziadek): odnośnik `tel:`, atrybuty opisowe pola (aria-label, placeholder, name, type=tel),
 * etykieta <label>, lokalna nazwa klasy, podpis tuż obok (poprzedni element) i nagłówek kolumny tabeli.
 * Zwraca „telefon", „inny" albo null (brak sygnału — wtedy maska maskuje, patrz `maskujTelefony`).
 */
export const kontekstNumeru = (element) => {
    let el = element;
    for (let poziom = 0; poziom < 3 && el && el.nodeType === 1; poziom += 1) {
        if (el.tagName === "BODY" || el.tagName === "HTML") break;
        const teksty = [klasyLokalne(el)];
        if (el.tagName === "A" && /^tel:/i.test(el.getAttribute("href") || "")) return "telefon";
        const pole = el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT";
        for (const a of ATRYBUTY_OTOCZENIA) {
            const v = el.getAttribute(a);
            if (!v) continue;
            // [R32, poprawka] `title`/`aria-label` zwykłego elementu to często KOPIA treści (temat zgłoszenia w `title`) —
            // liczy się tylko krótki podpis bez cyfr. Pole ma tam swoją etykietę, więc u pól liczy się zawsze.
            if (!pole && (a === "title" || a === "aria-label")) {
                const p = podpis(v);
                if (p) teksty.push(p);
                continue;
            }
            teksty.push(v);
        }
        if (el.labels) for (const l of el.labels) teksty.push((l.textContent || "").slice(0, 80));
        teksty.push(podpis(el.previousElementSibling && el.previousElementSibling.textContent));
        if (el.tagName === "TD" || el.tagName === "TH") teksty.push(naglowekKolumny(el));
        const razem = teksty.join(" | ");
        if (OTOCZENIE_TELEFON.test(razem)) return "telefon";
        if (OTOCZENIE_INNY.test(razem)) return "inny";
        el = el.parentElement;
    }
    return null;
};
const WLASCIWOSCI_POLA = [
    "background-image", "background-repeat", "background-position", "background-size", "background-attachment",
    "color", "-webkit-text-fill-color", "text-shadow", "caret-color",
];

/**
 * Zamaskowany napis pola jako obraz SVG (tło pola). Czcionka, rozmiar, kolor i wcięcie z wyliczonego stylu pola,
 * żeby maska stała tam, gdzie stałby prawdziwy tekst. Wiele linii = textarea. Bez układu (jsdom) wymiary
 * liczone z długości napisu.
 */
export const svgTekstuPola = (tekst, u = {}) => {
    const linie = u.wieleLinii ? String(tekst).split(/\r?\n/) : [String(tekst).replace(/\s+/g, " ")];
    const rozmiar = u.rozmiar || 14;
    const krok = u.wysokoscLinii || Math.round(rozmiar * 1.4);
    const lewy = u.lewy || 0;
    const gorny = u.gorny || 0;
    const najdluzsza = Math.max(...linie.map((l) => l.length));
    const szer = Math.max(u.szerokosc || 0, Math.ceil(najdluzsza * rozmiar * 0.62) + lewy + 8);
    const wys = Math.max(u.wysokosc || 0, u.wieleLinii ? gorny + linie.length * krok + 4 : Math.ceil(rozmiar * 2.2));
    const czcionka = escXml(String(u.czcionka || "system-ui, sans-serif").replace(/"/g, "'"));
    const kolor = escXml(u.kolor || "#475569");
    const wiersz = (l, y) => `<text x="${lewy}" y="${y}" dominant-baseline="middle" font-family="${czcionka}" font-size="${rozmiar}" fill="${kolor}">${escXml(l)}</text>`;
    const teksty = u.wieleLinii
        ? linie.map((l, i) => wiersz(l, gorny + krok * i + krok / 2)).join("")
        : wiersz(linie[0], wys / 2);
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="${szer}" height="${wys}">${teksty}</svg>`;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

/**
 * Czy element to kółko z inicjałami (awatar bez zdjęcia): jeden węzeł tekstowy z 1–3 wielkimi literami,
 * kształt kwadratowy do 96 px i zaokrąglenie kołowe. Plakietki „IT"/„HR" są pigułkami (szerokość ≠ wysokość),
 * więc odpadają na kształcie.
 */
export const jestAwataremDomyslnie = (el) => {
    if (!el || el.childNodes.length !== 1 || el.firstChild.nodeType !== 3) return false;
    if (!INICJALY_NA_EKRANIE.test((el.firstChild.nodeValue || "").trim())) return false;
    const w = el.offsetWidth;
    const h = el.offsetHeight;
    if (!w || Math.abs(w - h) > 2 || w > 96) return false;
    const widok = el.ownerDocument.defaultView;
    if (!widok) return false;
    const r = widok.getComputedStyle(el).borderRadius || "";
    const liczba = parseFloat(r);
    if (Number.isNaN(liczba)) return false;
    return r.endsWith("%") ? liczba >= 40 : liczba >= w / 2 - 1;
};

/* ── maska aktywna na stronie: dla treści, do której DOM maski nie sięga ─────────────────── */

let aktywnaMaska = null;
/** Zdarzenie na `window`, gdy maska strony startuje albo się zatrzymuje (podgląd ma wysłać treść jeszcze raz). */
export const ZDARZENIE_MASKI = "maska-nagrania-zmiana";
/**
 * [T2, właściciel 2026-09-14] Zdarzenie na `window` po UDANYM zapisie ustawień wersji anonimowej (TrybNagraniaToggle).
 * Komponent MaskaNagrania sprawdza wtedy tryb od razu, zamiast czekać na powrót do karty albo minutę.
 */
export const ZDARZENIE_TRYBU_NAGRANIA = "nagranie-tryb-zmieniony";
const oglosZmianeMaski = () => {
    try {
        if (typeof window !== "undefined" && typeof Event === "function") window.dispatchEvent(new Event(ZDARZENIE_MASKI));
    } catch { /* bez okna — nie ma komu ogłaszać */ }
};

/**
 * [R32, poprawka po przeglądzie 2026-09-13] Podgląd na żywo w konfiguratorze stopek (/admin) to ramka `sandbox="allow-scripts"`
 * bez własnego pochodzenia: treść przychodzi przez postMessage do stałego szkieletu, a do dokumentu ramki maska nie ma wstępu.
 * Wzór wypełnia się przykładową osobą, ale dane firmy (nazwa, adres, WWW, telefon) są prawdziwe. Strona przepuszcza HTML
 * przez tę funkcję PRZED wysłaniem. Brak maski albo „Maskuj stopki” wyłączone = HTML bez zmian. Kopiowany „Kod HTML”
 * zostaje prawdziwy — to nie ekran.
 */
export const maskujHtmlPodgladuStopki = (html) => {
    const m = aktywnaMaska;
    if (!m || typeof html !== "string" || !html || (m.opcje && m.opcje.stopki === false) || typeof m.maskujHtml !== "function") return html;
    return m.maskujHtml(html);
};

/**
 * Uruchamia maskę na drzewie DOM i pilnuje zmian (React dopisuje i podmienia węzły cały czas).
 * Zwraca funkcję zatrzymującą. `opcje.jestAwatarem` pozwala podmienić wykrywanie awatara (testy bez układu).
 * Ta sama funkcja uruchamia się rekurencyjnie na dokumencie ramki tego samego pochodzenia (`opcje.root` = jej body).
 */
export const uruchomMaskeDom = (maska, opcje = {}) => {
    const root = opcje.root || document.body;
    const glowna = !opcje.root;              // maska strony (nie dokumentu ramki) — tylko ona jest „aktywną maską”
    const doc = root.ownerDocument || document;
    const widok = doc.defaultView || window;
    const jestAwatarem = opcje.jestAwatarem || jestAwataremDomyslnie;
    const stopki = !maska.opcje || maska.opcje.stopki !== false;
    const zamiennikZdjecia = maska.zdjecieZastepcze || zdjecieZastepcze(maska.inicjaly);
    const ostatnie = new WeakMap();          // węzeł tekstowy → ostatnia wartość, jaką widzieliśmy/zapisaliśmy
    const ostatnieAtr = new WeakMap();       // element → { atrybut: ostatnia wartość }
    const ostatniePola = new WeakMap();      // pole → ostatnia narysowana maska
    const ostatnieSrcdoc = new WeakMap();    // ramka → ostatni srcdoc, jaki widzieliśmy/zapisaliśmy
    const ramkiWewnatrz = new Map();         // ramka → { stop, cialo } maski w jej dokumencie
    const nasluchyRamek = new Map();         // ramka → handler `load`

    const pomijany = (el) => !!(el && el.closest && el.closest(POMIJANE));
    const pomijanyDrzewem = (el) => !!(el && el.closest && el.closest(POMIJANE_DRZEWO));
    const telefony = !maska.opcje || maska.opcje.telefony !== false;
    const prawdziwe = new WeakMap();         // węzeł tekstowy → jego PRAWDZIWY napis (ostatni, którego nie zapisała maska)
    const wBiegu = new WeakSet();            // węzły ostatnio maskowane razem z sąsiadami (patrz `maskujBieg`)

    // [poprawka po przeglądzie 2026-09-13] PRAWDA SPRZED MASKI dla elementów. Zatrzymanie maski (zmiana konta bez przeładowania)
    // ma przywrócić ekran: napisy, atrybuty opisowe, zdjęcia, ramki i wartości <option> — nie tylko pola.
    const oryginalneAtr = new WeakMap();     // element → { atrybut: prawdziwa wartość }, tylko tam, gdzie maska coś zmieniła
    const oryginalneZdjecia = new WeakMap(); // <img> → { src, srcset } sprzed podmiany
    const oryginalneSrcdoc = new WeakMap();  // ramka → prawdziwy srcdoc
    const wartosciOpcji = new WeakMap();     // <option> → `value` dopisany przez maskę

    /**
     * Otoczenie numeru (telefon czy MPK) liczone TYLKO, gdy w napisie stoi coś o kształcie telefonu — skan DOM kosztuje.
     * `przed` = tekst poprzednich węzłów tego samego elementu (podpis „MPK " w osobnym węźle przed „{kod}").
     */
    const kontekstDla = (el, tekst, przed, po, podpowiedz) => {
        const numery = telefony && el && wygladaNaTelefon(tekst) ? kontekstNumeru(el) : undefined;
        if (numery === undefined && !przed) return undefined;
        return { numery, przed: przed || "", po: po || "", podpowiedz: !!podpowiedz };
    };

    /**
     * Prawdziwy napis węzła. Jeżeli w węźle stoi to, co ostatnio zapisała maska — prawdziwy jest zapamiętany; w każdym
     * innym wypadku napis przyszedł od Reacta (albo od kogokolwiek poza maską) i TO jest nowa prawda.
     */
    const prawdziwyTekst = (n) => {
        const v = n.nodeValue;
        if (ostatnie.has(n) && ostatnie.get(n) === v) return prawdziwe.has(n) ? prawdziwe.get(n) : v;
        prawdziwe.set(n, v);
        return v;
    };
    /** Odczyt bez zapamiętywania (do składania wartości <option>). */
    const odczytPrawdziwy = (d) => (d.nodeType === 3 && ostatnie.has(d) && ostatnie.get(d) === d.nodeValue && prawdziwe.has(d)
        ? prawdziwe.get(d)
        : d.textContent);

    /**
     * [R28] <option> BEZ atrybutu `value` ma wartość równą swojemu TEKSTOWI. Zamaskowanie tekstu zmieniłoby więc to,
     * co <select> oddaje do stanu Reacta i do zapisu (a React przestałby zaznaczać wybraną opcję). Zanim podmienimy
     * napis, prawdziwy tekst opcji trafia do atrybutu `value` — wartość opcji zostaje prawdziwa, zmienia się tylko ekran.
     * Opcji z WŁASNYM `value` (React: `<option value={id}>`) to nie dotyczy i nic tam nie dopisujemy.
     * Wołane PRZED zapisem maski do węzłów (odczyt prawdziwych napisów).
     */
    const utrwalWartoscOpcji = (opcja) => {
        if (opcja.hasAttribute("value") && !opcja.hasAttribute(ATRYBUT_OPCJI)) return;
        const tekst = [...opcja.childNodes].map(odczytPrawdziwy).join("").replace(/\s+/g, " ").trim();
        opcja.setAttribute(ATRYBUT_OPCJI, "");
        if (opcja.getAttribute("value") !== tekst) opcja.setAttribute("value", tekst);
        wartosciOpcji.set(opcja, tekst);
    };

    const sasiadTekstowy = (n) => (n.previousSibling && n.previousSibling.nodeType === 3) || (n.nextSibling && n.nextSibling.nodeType === 3);

    /**
     * [R28] Bieg węzłów tekstowych jednego elementu: JSX `{o.nazwisko} {o.imie}` („Sosidko", „ ", „Grzegorz") albo
     * `Dodaj do akt: {lastName} {firstName}`. Każdy węzeł dostaje maskę własnego napisu (z tekstem poprzednich węzłów
     * jako podpisem numeru), a osoba przechodząca przez granicę węzłów — `maskujOsobyWPoprzek`: zamiennik w węźle,
     * gdzie zaczyna się trafienie, reszta trafienia w kolejnych węzłach pusta. Prawdziwe napisy każdego węzła są
     * zapamiętane, więc zmiana jednego węzła przez Reacta przelicza bieg od prawdy, a nie od maski.
     */
    const maskujBieg = (n, wymus) => {
        let pierwszy = n;
        while (pierwszy.previousSibling && pierwszy.previousSibling.nodeType === 3) pierwszy = pierwszy.previousSibling;
        const wezly = [];
        for (let x = pierwszy; x && x.nodeType === 3; x = x.nextSibling) wezly.push(x);
        if (!wymus && wezly.every((x) => ostatnie.has(x) && ostatnie.get(x) === x.nodeValue)) return;
        const rodzic = n.parentElement;
        if (rodzic && pomijany(rodzic)) return;
        const prawda = wezly.map(prawdziwyTekst);
        let przed = "";
        const maski = prawda.map((p, i) => {
            // `po` = napisy dalszych węzłów biegu: numer sam w swoim węźle nie jest „samotny” w zdaniu „{tekst} {numer} {tekst}”.
            const po = prawda.slice(i + 1).join("").slice(0, 200);
            const m = p && /\S/.test(p) ? maska.maskuj(p, kontekstDla(rodzic, p, przed.slice(-200), po)) : p;
            przed += p || "";
            return m;
        });
        const wynik = (maska.maskujOsobyWPoprzek && maska.maskujOsobyWPoprzek(maski)) || maski;
        const zmiana = wynik.some((m, i) => m !== prawda[i]);
        if (rodzic && rodzic.tagName === "OPTION" && (zmiana || rodzic.hasAttribute(ATRYBUT_OPCJI))) utrwalWartoscOpcji(rodzic);
        wezly.forEach((x, i) => {
            wBiegu.add(x);
            ostatnie.set(x, wynik[i]);
            if (x.nodeValue !== wynik[i]) x.nodeValue = wynik[i];
        });
    };

    const maskujTekst = (n, wymus) => {
        if (!n || n.nodeType !== 3) return;
        if (sasiadTekstowy(n)) { maskujBieg(n, wymus); return; }
        const v = n.nodeValue;
        // Węzeł, który był częścią biegu (mógł dostać pusty napis albo cudzy zamiennik), liczymy od prawdy.
        const zBiegu = wBiegu.has(n);
        if (!zBiegu && !wymus) {
            if (!v || !/\S/.test(v)) return;
            if (ostatnie.get(n) === v) return; // nasz własny zapis albo nic się nie zmieniło
        }
        const rodzic = n.parentElement;
        if (rodzic && pomijany(rodzic)) return;
        const prawdziwy = prawdziwyTekst(n);
        wBiegu.delete(n);
        let m = prawdziwy && /\S/.test(prawdziwy) ? maska.maskuj(prawdziwy, kontekstDla(rodzic, prawdziwy)) : prawdziwy;
        if (rodzic && prawdziwy && /\S/.test(prawdziwy) && jestAwatarem(rodzic)) {
            m = maska.inicjaly;
            if (!rodzic.hasAttribute(ATRYBUT_AWATARA)) rodzic.setAttribute(ATRYBUT_AWATARA, "");
        }
        if (rodzic && rodzic.tagName === "OPTION" && (m !== prawdziwy || rodzic.hasAttribute(ATRYBUT_OPCJI))) {
            utrwalWartoscOpcji(rodzic);
        }
        ostatnie.set(n, m);
        if (m !== v) n.nodeValue = m;
    };

    const maskujAtrybuty = (el) => {
        if (!el.getAttribute || pomijanyDrzewem(el)) return;
        let pamiec = ostatnieAtr.get(el);
        for (const a of ATRYBUTY) {
            const v = el.getAttribute(a);
            if (!v) continue;
            if (pamiec && pamiec[a] === v) continue;
            const podpowiedzPola = a === "placeholder" && (el.tagName === "INPUT" || el.tagName === "TEXTAREA");
            const m = maska.maskuj(v, kontekstDla(el, v, "", "", podpowiedzPola));
            if (!pamiec) { pamiec = {}; ostatnieAtr.set(el, pamiec); }
            pamiec[a] = m;
            // `v` jest tu zawsze nowym napisem spoza maski (nasz własny zapis odpadł wyżej) — to on jest prawdą.
            let prawda = oryginalneAtr.get(el);
            if (m !== v) {
                if (!prawda) { prawda = {}; oryginalneAtr.set(el, prawda); }
                prawda[a] = v;
                el.setAttribute(a, m);
            } else if (prawda) delete prawda[a];
        }
    };

    // ── zdjęcia osób: podmiana `src` na neutralny SVG, element zostaje ─────────────────────
    const maskujZdjecie = (img) => {
        if (pomijanyDrzewem(img) || !jestZdjeciemOsoby(img, maska.zawieraOsobe)) return;
        if (img.getAttribute("src") === zamiennikZdjecia && img.hasAttribute(ATRYBUT_ZDJECIA)) return;
        const src = img.getAttribute("src");
        const poprzednie = oryginalneZdjecia.get(img);
        oryginalneZdjecia.set(img, {
            src: src !== zamiennikZdjecia ? src : (poprzednie ? poprzednie.src : null),
            srcset: img.hasAttribute("srcset") ? img.getAttribute("srcset") : (poprzednie ? poprzednie.srcset : null),
        });
        img.setAttribute(ATRYBUT_ZDJECIA, "");
        if (img.hasAttribute("srcset")) img.removeAttribute("srcset");
        img.setAttribute("src", zamiennikZdjecia);
    };

    // ── pola: maska rysowana jako tło, WARTOŚĆ NIETKNIĘTA ─────────────────────────────────
    const oryginalneStyle = new WeakMap();   // pole → [[właściwość, wartość, priorytet]] ze stylu inline sprzed maski

    /**
     * React potrafi nadpisać styl inline pola (`style={{ color }}`) — przezroczystość znika i prawdziwy tekst wyszedłby
     * spod maski. Obserwujemy WYŁĄCZNIE atrybut `style` pól z maską (nie całej strony: framer-motion zmienia style
     * w każdej klatce animacji i obserwator całego drzewa tonąłby w zapisach).
     */
    const naszeTlo = (el) => (el.style.getPropertyValue("background-image") || "").indexOf("data:image/svg+xml") !== -1;
    const obserwatorStylu = new widok.MutationObserver((zmiany) => {
        for (const z of zmiany) {
            const el = z.target;
            if (!el.hasAttribute(ATRYBUT_POLA)) continue;
            const kolor = el.style.getPropertyValue("color");
            const tlo = naszeTlo(el);
            if (kolor === "transparent" && tlo) continue;
            // Wartości od Reacta są nowym stanem „sprzed maski" — to one wracają po zatrzymaniu maski.
            (oryginalneStyle.get(el) || []).forEach((wpis) => {
                if ((wpis[0] === "color" && kolor !== "transparent") || (wpis[0] === "background-image" && !tlo)) {
                    wpis[1] = el.style.getPropertyValue(wpis[0]);
                    wpis[2] = el.style.getPropertyPriority(wpis[0]);
                }
            });
            if (kolor !== "transparent") el.removeAttribute("data-maska-kolor"); // nowy kolor tekstu — maska ma go przejąć
            ostatniePola.delete(el);
            maskujPole(el);
        }
    });

    const zdejmijMaskePola = (el) => {
        const s = el.style;
        WLASCIWOSCI_POLA.forEach((p) => s.removeProperty(p));
        (oryginalneStyle.get(el) || []).forEach(([p, wartosc, priorytet]) => { if (wartosc) s.setProperty(p, wartosc, priorytet); });
        oryginalneStyle.delete(el);
        el.removeAttribute(ATRYBUT_POLA);
        el.removeAttribute("data-maska-kolor");
        ostatniePola.delete(el);
    };

    const narysujMaskePola = (el, tekst) => {
        if (!el.hasAttribute(ATRYBUT_POLA)) {
            oryginalneStyle.set(el, WLASCIWOSCI_POLA.map((p) => [p, el.style.getPropertyValue(p), el.style.getPropertyPriority(p)]));
            obserwatorStylu.observe(el, { attributes: true, attributeFilter: ["style"] });
        }
        const cs = widok.getComputedStyle ? widok.getComputedStyle(el) : null;
        // Kolor prawdziwego tekstu zapamiętany PRZED zrobieniem go przezroczystym — maska i kursor w tym kolorze (oba motywy).
        let kolor = el.getAttribute("data-maska-kolor");
        if (!kolor) {
            kolor = (cs && cs.color) || "#475569";
            el.setAttribute("data-maska-kolor", kolor);
        }
        const svg = svgTekstuPola(tekst, {
            kolor,
            czcionka: (cs && cs.fontFamily) || "system-ui, sans-serif",
            rozmiar: parseFloat(cs && cs.fontSize) || 14,
            wysokoscLinii: parseFloat(cs && cs.lineHeight) || 0,
            lewy: parseFloat(cs && cs.paddingLeft) || 0,
            gorny: parseFloat(cs && cs.paddingTop) || 0,
            szerokosc: el.clientWidth || 0,
            wysokosc: el.clientHeight || 0,
            wieleLinii: el.tagName === "TEXTAREA",
        });
        el.setAttribute(ATRYBUT_POLA, "");
        const s = el.style;
        s.setProperty("background-image", `url("${svg}")`, "important");
        s.setProperty("background-repeat", "no-repeat", "important");
        s.setProperty("background-position", "0 0", "important");
        s.setProperty("background-size", "auto", "important");
        s.setProperty("background-attachment", "local", "important");
        s.setProperty("color", "transparent", "important");
        s.setProperty("-webkit-text-fill-color", "transparent", "important");
        s.setProperty("text-shadow", "none", "important");
        s.setProperty("caret-color", kolor, "important");
    };

    const maskujPole = (el) => {
        if (!el || pomijanyDrzewem(el)) return;
        if (el.tagName === "INPUT" && !TYPY_POL_TEKSTOWYCH.has((el.getAttribute("type") || "").toLowerCase())) return;
        // Wyłącznie ODCZYT `.value`. Ten moduł nigdy nie przypisuje wartości pola — zapadka to mierzy (R28).
        const v = typeof el.value === "string" ? el.value : "";
        const m = maska.maskuj(v, kontekstDla(el, v));
        if (m === v) {
            if (el.hasAttribute(ATRYBUT_POLA)) zdejmijMaskePola(el);
            return;
        }
        if (ostatniePola.get(el) === m && el.hasAttribute(ATRYBUT_POLA)) return;
        ostatniePola.set(el, m);
        narysujMaskePola(el, m);
    };

    // ── ramki: `srcdoc` maskowany jako dokument; ramka tego samego pochodzenia dostaje własną maskę ──
    const maskujDokumentRamki = (ramka) => {
        let d = null;
        try { d = ramka.contentDocument; } catch { d = null; } // sandbox / obce pochodzenie — nie ma wstępu
        const cialo = d && d.body;
        const poprzednie = ramkiWewnatrz.get(ramka);
        // Porównujemy CIAŁO, nie dokument: `document.open()/write()` podmienia <body> w TYM SAMYM dokumencie,
        // a obserwator zawieszony na starym ciele nie zobaczyłby już niczego.
        if (poprzednie && poprzednie.cialo === cialo) return;
        if (poprzednie) { poprzednie.stop(); ramkiWewnatrz.delete(ramka); }
        if (!cialo) return;
        ramkiWewnatrz.set(ramka, { stop: uruchomMaskeDom(maska, { ...opcje, root: cialo }), cialo });
        ramka.setAttribute(ATRYBUT_RAMKI, "");
    };

    /**
     * Opcja „Maskuj stopki" dotyczy RAMEK PODGLĄDU STOPKI (wszystkie mają „stopk…" w tytule lub klasie — Pulpit,
     * Moja stopka, konfigurator). Ramki z dokumentami kadrowymi (wnioski, podgląd A4) maskujemy zawsze: to ta sama
     * treść co strona, tylko w ramce — wyłączenie stopek nie może odsłonić nazwisk w dokumentach.
     */
    const jestRamkaStopki = (ramka) => {
        let el = ramka;
        for (let i = 0; i < 3 && el && el.nodeType === 1; i += 1) {
            if (/stopk|signature|sygnatur/i.test(`${el.getAttribute("title") || ""} ${klasyLokalne(el)} ${el.getAttribute("aria-label") || ""}`)) return true;
            el = el.parentElement;
        }
        return false;
    };

    const maskujRamke = (ramka) => {
        if (pomijanyDrzewem(ramka)) return;
        if (!stopki && jestRamkaStopki(ramka)) return;
        const sd = ramka.getAttribute("srcdoc");
        if (sd && ostatnieSrcdoc.get(ramka) !== sd) {
            const m = maska.maskujHtml(sd);
            ostatnieSrcdoc.set(ramka, m);
            if (m !== sd) {
                oryginalneSrcdoc.set(ramka, sd);
                ramka.setAttribute("srcdoc", m);
            } else oryginalneSrcdoc.delete(ramka);
        }
        if (!nasluchyRamek.has(ramka)) {
            const naLoad = () => maskujDokumentRamki(ramka);
            nasluchyRamek.set(ramka, naLoad);
            ramka.addEventListener("load", naLoad);
        }
        maskujDokumentRamki(ramka);
    };

    const maskujElement = (el) => {
        const tag = el.tagName;
        if (tag === "INPUT" || tag === "TEXTAREA") { maskujAtrybuty(el); maskujPole(el); return; }
        // Zdjęcie PRZED atrybutami: rozpoznanie po `alt` potrzebuje jeszcze prawdziwego nazwiska.
        if (tag === "IMG") maskujZdjecie(el);
        maskujAtrybuty(el);
        if (tag === "IFRAME") maskujRamke(el);
    };

    const maskujPoddrzewo = (wezel) => {
        if (wezel.nodeType === 3) { maskujTekst(wezel); return; }
        if (wezel.nodeType !== 1 && wezel.nodeType !== 11) return;
        if (wezel.nodeType === 1) {
            if (wezel.matches && wezel.matches(POMIJANE_DRZEWO)) return;
            maskujElement(wezel);
        }
        const walker = doc.createTreeWalker(wezel, 5 /* SHOW_ELEMENT | SHOW_TEXT */, {
            acceptNode: (n) => (n.nodeType === 1 && n.matches(POMIJANE_DRZEWO) ? 2 /* REJECT */ : 1),
        });
        let n = walker.nextNode();
        while (n) {
            if (n.nodeType === 3) maskujTekst(n);
            else maskujElement(n);
            n = walker.nextNode();
        }
    };

    // Neutralny wygląd awatara z inicjałami aplikacji (kolory z tokenów — oba motywy) i zdjęcia zastępczego.
    let styl = doc.querySelector("style[data-maska-nagrania]");
    if (!styl) {
        styl = doc.createElement("style");
        styl.setAttribute("data-maska-nagrania", "");
        styl.textContent = `[${ATRYBUT_AWATARA}]{background:var(--color-bg-tertiary,#e2e8f0)!important;color:var(--color-text-secondary,#475569)!important;}`
            + `img[${ATRYBUT_ZDJECIA}]{object-fit:cover;}`;
        (doc.head || doc.documentElement).appendChild(styl);
    }

    maskujPoddrzewo(root);
    // [poprawka po przeglądzie 2026-09-13] TYTUŁ KARTY. <title> żyje w <head>, poza obserwatorem `root`, a strony ustawiają
    // go PO starcie maski (WorkTimeUserSections → „Czas pracy — {imię i nazwisko}”). Nagranie całego okna pokazuje kartę.
    // Osobny, lekki obserwator na <head>; własny zapis rozpoznajemy po wartości (bez pętli). Prawda wraca po zatrzymaniu.
    let tytulPrawdziwy = null;
    let tytulZamaskowany = null;
    const maskujTytul = () => {
        const t = doc.title;
        if (!t || t === tytulZamaskowany) return;
        const m = maska.maskuj(t);
        tytulPrawdziwy = t;
        tytulZamaskowany = m;
        if (m !== t) doc.title = m;
    };
    maskujTytul();
    const obserwatorTytulu = doc.head ? new widok.MutationObserver(maskujTytul) : null;
    if (obserwatorTytulu) obserwatorTytulu.observe(doc.head, { subtree: true, childList: true, characterData: true });

    /** Zmiana WEWNĄTRZ textarea (React ustawia defaultValue = tekst dziecka) to sygnał do przerysowania maski pola. */
    const poleNadrzedne = (n) => {
        const el = n.nodeType === 1 ? n : n.parentElement;
        return el && el.closest ? el.closest("textarea") : null;
    };

    const obserwator = new widok.MutationObserver((zmiany) => {
        for (const z of zmiany) {
            if (z.type === "characterData") {
                const pole = poleNadrzedne(z.target);
                if (pole) maskujPole(pole); else maskujTekst(z.target);
            } else if (z.type === "attributes") {
                const t = z.target;
                const a = z.attributeName;
                if (a === "src" || a === "srcset") { if (t.tagName === "IMG") maskujZdjecie(t); }
                else if (a === "srcdoc") { if (t.tagName === "IFRAME") maskujRamke(t); }
                else if (a === "value") { if (t.tagName === "INPUT") maskujPole(t); } // React: value prop → defaultValue → atrybut
                else {
                    if (a === "alt" && t.tagName === "IMG") maskujZdjecie(t);
                    maskujAtrybuty(t);
                }
            } else {
                const pole = poleNadrzedne(z.target);
                if (pole) { maskujPole(pole); continue; }
                z.addedNodes.forEach(maskujPoddrzewo);
                // Zniknął węzeł z biegu („{imie} {nazwisko}" → „{imie}"): sąsiedzi liczeni od nowa, od prawdy.
                if (z.removedNodes.length > 0) {
                    [z.previousSibling, z.nextSibling].forEach((x) => { if (x && x.nodeType === 3 && x.parentNode) maskujTekst(x, true); });
                }
            }
        }
    });
    obserwator.observe(root, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ATRYBUTY_OBSERWOWANE,
    });

    // Pisanie w polu nie zmienia atrybutów — maskę pola przerysowuje zdarzenie `input` (delegowane, faza przechwytywania).
    const naWpis = (e) => {
        const t = e.target;
        if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA")) maskujPole(t);
    };
    root.addEventListener("input", naWpis, true);
    root.addEventListener("change", naWpis, true);

    /**
     * Zatrzymanie przywraca ekran — WYŁĄCZNIE tam, gdzie nadal stoi zapis maski (to, co w międzyczasie zmienił React,
     * jest już prawdą i zostaje). Obchodzimy bieżące drzewo: odłączone węzły nie są na ekranie, a mapy są słabe.
     */
    const przywroc = () => {
        const przywrocWezel = (n) => {
            if (n.nodeType === 3) {
                if (ostatnie.has(n) && ostatnie.get(n) === n.nodeValue && prawdziwe.has(n) && prawdziwe.get(n) !== n.nodeValue) {
                    n.nodeValue = prawdziwe.get(n);
                }
                return;
            }
            if (n.nodeType !== 1) return;
            const pamiec = ostatnieAtr.get(n);
            const prawda = oryginalneAtr.get(n);
            if (pamiec && prawda) {
                Object.keys(prawda).forEach((a) => { if (n.getAttribute(a) === pamiec[a]) n.setAttribute(a, prawda[a]); });
            }
            if (n.hasAttribute(ATRYBUT_AWATARA)) n.removeAttribute(ATRYBUT_AWATARA);
            if (n.tagName === "IMG" && n.hasAttribute(ATRYBUT_ZDJECIA)) {
                const z = oryginalneZdjecia.get(n);
                if (z && n.getAttribute("src") === zamiennikZdjecia) {
                    if (z.src != null) n.setAttribute("src", z.src); else n.removeAttribute("src");
                    if (z.srcset != null) n.setAttribute("srcset", z.srcset);
                }
                n.removeAttribute(ATRYBUT_ZDJECIA);
            }
            if (n.tagName === "IFRAME" && oryginalneSrcdoc.has(n) && n.getAttribute("srcdoc") === ostatnieSrcdoc.get(n)) {
                n.setAttribute("srcdoc", oryginalneSrcdoc.get(n));
            }
            if (n.tagName === "IFRAME" && n.hasAttribute(ATRYBUT_RAMKI)) n.removeAttribute(ATRYBUT_RAMKI);
            if (n.tagName === "OPTION" && n.hasAttribute(ATRYBUT_OPCJI)) {
                // Bez dopisanego `value` opcja znów oddaje swój (już prawdziwy) tekst — <select> nie trzyma starej wartości.
                if (wartosciOpcji.has(n) && n.getAttribute("value") === wartosciOpcji.get(n)) n.removeAttribute("value");
                n.removeAttribute(ATRYBUT_OPCJI);
            }
        };
        przywrocWezel(root);
        const walker = doc.createTreeWalker(root, 5 /* SHOW_ELEMENT | SHOW_TEXT */, null);
        let n = walker.nextNode();
        while (n) { przywrocWezel(n); n = walker.nextNode(); }
        if (tytulZamaskowany !== null && tytulPrawdziwy !== null && doc.title === tytulZamaskowany) doc.title = tytulPrawdziwy;
    };

    /**
     * [T2, właściciel 2026-09-14] „Wyłączyłem tryb anonimowy a dalej …”. Maska schodzi teraz W TRAKCIE sesji (bez F5), więc
     * zatrzymanie mówi, czy ekran naprawdę wrócił do prawdy. Przywrócenie opiera się na pamięci maski per węzeł — nie odda
     * napisu, który zamaskowany przeszedł do STANU strony (skopiowany `innerHTML`, napis przepisany z DOM-u do stanu i
     * wyrenderowany od nowa, `srcdoc` złożony z zamaskowanego HTML-u). Tego rodzaju zmiany maska nie umie cofnąć, więc po
     * przywróceniu obchodzi bieżące drzewo jeszcze raz i liczy ŚLADY: zdjęcie zastępcze, pozostawiony znacznik maski,
     * zamiennik osoby z numerem albo zastępczy e-mail (`maska.wzorSladu`) w napisie, atrybucie opisowym, `srcdoc` i tytule
     * karty. Pola, edytor i `[data-bez-maski]` są pomijane — ich treść to praca użytkownika (przeładowanie by ją zabrało),
     * a maska ich wartości nigdy nie zmienia. Ślad = przywrócenie NIEPEŁNE; decyzję (przeładowanie) podejmuje komponent.
     */
    const policzSlady = () => {
        const rodzaje = new Set();
        let ile = 0;
        const wzor = maska.wzorSladu instanceof RegExp ? maska.wzorSladu : null;
        const maSlad = (t) => !!(wzor && typeof t === "string" && t.length > 2 && wzor.test(t));
        const slad = (rodzaj) => { ile += 1; rodzaje.add(rodzaj); };
        const znaczniki = [ATRYBUT_ZDJECIA, ATRYBUT_AWATARA, ATRYBUT_POLA, ATRYBUT_OPCJI, ATRYBUT_RAMKI];
        const sprawdzWezel = (n) => {
            if (n.nodeType === 3) { if (maSlad(n.nodeValue)) slad("napis"); return; }
            if (n.nodeType !== 1) return;
            if (n.tagName === "IMG" && n.getAttribute("src") === zamiennikZdjecia) slad("zdjecie");
            if (znaczniki.some((a) => n.hasAttribute(a))) slad("znacznik");
            if (ATRYBUTY.some((a) => maSlad(n.getAttribute(a)))) slad("atrybut");
            if (n.tagName === "IFRAME" && maSlad(n.getAttribute("srcdoc"))) slad("ramka");
        };
        if (root.nodeType === 1 && !(root.matches && root.matches(POMIJANE))) sprawdzWezel(root);
        const walker = doc.createTreeWalker(root, 5 /* SHOW_ELEMENT | SHOW_TEXT */, {
            acceptNode: (n) => (n.nodeType === 1 && n.matches(POMIJANE) ? 2 /* REJECT */ : 1),
        });
        let n = walker.nextNode();
        while (n) { sprawdzWezel(n); n = walker.nextNode(); }
        if (maSlad(doc.title)) slad("tytul"); // każda maska pilnuje tytułu SWOJEGO dokumentu (`maskujTytul`)
        return { ile, rodzaje };
    };

    if (glowna) { aktywnaMaska = maska; oglosZmianeMaski(); }

    /**
     * Zatrzymanie zwraca RAPORT { pelne, slady, rodzaje } (dotychczasowi wołający mogą go pominąć). `pelne: false` = na ekranie
     * (albo w dokumencie ramki tego samego pochodzenia) został ślad maski, którego przywrócenie nie cofnęło — patrz `policzSlady`.
     */
    return () => {
        obserwator.disconnect();
        obserwatorStylu.disconnect();
        root.removeEventListener("input", naWpis, true);
        root.removeEventListener("change", naWpis, true);
        nasluchyRamek.forEach((h, r) => r.removeEventListener("load", h));
        nasluchyRamek.clear();
        let slady = 0;
        const rodzaje = new Set();
        ramkiWewnatrz.forEach((w, ramka) => {
            const r = w.stop();
            // Ramka, której `srcdoc` za chwilę wraca do prawdy (`przywroc`, ten sam warunek), przeładowuje się w przeglądarce
            // i jej obecny dokument — złożony z zamaskowanego `srcdoc` — przepada. Jego ślady nie są śladami ekranu po
            // zatrzymaniu; liczenie ich przeładowywało całą stronę (edytor wzoru HR z podglądem A4 tracił niezapisaną pracę).
            const srcdocWraca = oryginalneSrcdoc.has(ramka) && ramka.getAttribute("srcdoc") === ostatnieSrcdoc.get(ramka);
            if (srcdocWraca) return;
            if (r && r.slady) { slady += r.slady; (r.rodzaje || []).forEach((x) => rodzaje.add(x)); }
        });
        ramkiWewnatrz.clear();
        if (obserwatorTytulu) obserwatorTytulu.disconnect();
        if (root.querySelectorAll) root.querySelectorAll(`[${ATRYBUT_POLA}]`).forEach(zdejmijMaskePola);
        przywroc();
        if (styl && styl.parentNode) styl.parentNode.removeChild(styl);
        const wlasne = policzSlady();
        slady += wlasne.ile;
        wlasne.rodzaje.forEach((x) => rodzaje.add(x));
        if (glowna && aktywnaMaska === maska) { aktywnaMaska = null; oglosZmianeMaski(); }
        return { pelne: slady === 0, slady, rodzaje: [...rodzaje] };
    };
};
